import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { NavLink } from "react-router-dom";
import SkeletonCardLoad from "../../../components/SkeletonCardLoad";
import { AccommodationTable, EntryMode, PutAccommodationSetEntry, PutAccommodationTable } from "../../../models/Admin/AccommodationTable";
import msalRestClient from "../../../services/clients/MsalRestClient";
import AccommodationTableEntry from "./AccommodationTableEntry";

const AccommodationTableEdit = () => {

    // #region Init Status

    let initTable: PutAccommodationTable = {
        id               : -1,
        name             : "",
        description      : "",
        accommodationSet : []
    }

    // #endregion

    const { id } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [table, setTable]         = useState<PutAccommodationTable>(initTable);
    const [errors, setErrors]       = useState<string[]>([]);

    useEffect(() => {
        fetchFromApi();
    }, [])

    /**
     * TBD ...
     */
    const fetchFromApi = () => {

        setIsLoading(true);

        msalRestClient.get<AccommodationTable>("/api/accommodation/" + id)
            .then(response => {
                if (response.status === 200) {
                    setTable({
                        id: response.data.id,
                        name: response.data.name,
                        description: response.data.description,
                        accommodationSet: response.data.accommodationSet.map(x => ({ id: x.id, countryId: x.countryId, accommodation: x.accommodation, mode: EntryMode.Display }))
                    })
                }
            })
            .finally(() => { setIsLoading(false); })
    }

    /**
     * TBD ...
     * @param entry
     * @param index
     */
    const onSubmitEntry = (entry: PutAccommodationSetEntry, index: Number) => {
        let accommodations = table.accommodationSet.map((item, i) => (i === index ? entry : item));
        setTable(x => ({ ...x, accommodationSet: accommodations }));
    }

    /**
     * TBD ...
     * @param index
     */
    const onDeleteEntry = (index: number) => {

        let accommodations = table.accommodationSet.filter((x, i) => i !== index);
        setTable(x => ({ ...x, accommodationSet: accommodations }));
    }

    /**
     * Callback function called by clicking the "Create New" Button
     */
    const onNewEntryClick = () => {
        let newEntry: PutAccommodationSetEntry = {
            id: 0,
            countryId: 0,
            accommodation: 0,
            mode: EntryMode.Create
        }

        setTable(x => ({ ...x, accommodationSet: [...x.accommodationSet, newEntry] }));
    }

    /**
     * TBD ...
     */
    async function onSubmit(): Promise<void> {

        msalRestClient.put<AccommodationTable>("/api/accommodation", table)
            .then(response => {
                if (response.status === 200) { navigate("/admin/accommodations"); }
            })
            .catch((err: AxiosError) => {
                if (err.response!.status === 422) {
                    if (err.response?.data && (err.response?.data as string)) {
                        setErrors([err.response.data as string])
                    }
                }
            })
    }

    /**
     * Render function for render a error pane.
     * @returns JSX Element thats represents a list of error messages to user.
     */
    const renderErrorPane = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-danger">
                        <p className="fw-bold mb-0">Whoops! There were some problems with your input.</p>
                        <ul className="mb-0">
                            {
                                errors.map((value, index) => {
                                    return (
                                        <li key={"err_" + index}>{value}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <main className="container mb-4">

            <div className="row mb-2">
                <div className="col-12 text-end">
                    <NavLink to="/admin/accommodations" className="btn btn-danger">
                        <i className="bi bi-x-lg" />
                    </NavLink>
                </div>
            </div>

            <div className="row">
                <div className="col-12">

                    <div className="card">
                        <div className="card-body">

                            {
                                isLoading ? <SkeletonCardLoad cardsCount={1} />
                                    :
                                    <>
                                        {(errors.length > 0) && renderErrorPane()}

                                        <div className="form-group col-md-12">
                                            <label className="fw-bold" htmlFor="tableName">Tablename</label>
                                            <input type="text" className="form-control" id="tableName" name="tableName" value={table.name} onChange={e => setTable(x => ({ ...x, name: e.target.value }))} />
                                        </div>

                                        <div className="form-group col-md-12">
                                            <label className="fw-bold" htmlFor="description">Description</label>
                                            <textarea cols={1} rows={5} className="form-control" id="description" value={table.description} name="description" onChange={e => setTable(x => ({ ...x, description: e.target.value }))} />
                                        </div>

                                        <div className="col-12">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={3}>
                                                            <button className="btn btn-success" onClick={onNewEntryClick}>
                                                                <i className="bi bi-plus-lg me-1"></i>Add new Accommodation
                                                            </button>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>Country</th>
                                                        <th>Refund</th>
                                                        <th>
                                                            {  /* Empty for controls */}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        table.accommodationSet.map((value, index) => {
                                                            return <AccommodationTableEntry index={index} value={value} onConfirm={onSubmitEntry} onDelete={onDeleteEntry} selectedCountries={table.accommodationSet.map(x => x.countryId)} />
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                            }

                        </div>

                        <div className="card-footer text-end">
                            <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg me-1"></i>Validate and Create</button>
                        </div>

                    </div>

                </div>
            </div>


        </main>
    )
}
export default AccommodationTableEdit;